import React, { useEffect, useState } from 'react';
import { useFeedbackTopControl } from './FeedbackPopup';
import './FeedbackPopup.css';

// Floating scroll-to-top control for long, scroll-heavy pages.
export default function BackToTop({ threshold = 400, bottom = 24 }: any) {
  const [visible, setVisible] = useState<any>(false);
  const registerTopControl = useFeedbackTopControl();

  useEffect(() => {
    if (!visible || !registerTopControl) return undefined;
    registerTopControl((count) => count + 1);
    return () => registerTopControl((count) => count - 1);
  }, [visible, registerTopControl]);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      className="ae-floating-control ae-back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      title="Back to top"
      style={{
        bottom: `calc(${bottom}px + env(safe-area-inset-bottom, 0px))`,
      }}
    >
      <span aria-hidden="true">↑</span>
      Top
    </button>
  );
}
